export default __webpack_public_path__ + "static/media/product-person--green.37c3c7b6.svg";